import { inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { baseUrl } from "../../../../../../../core/constants/base-url";
import { CopyRrcLimitParams } from "../types/rrc-limits-copy-config.types";
import { rrcLimitsCopyResourceType } from "../configs/rrc-limits-copy-config";

@Injectable({
  providedIn: 'root'
})
export class RrcLimitsCopyApiService {
  private http: HttpClient = inject(HttpClient);

  public copyRrcLimit(params: CopyRrcLimitParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${rrcLimitsCopyResourceType.path}/copy`, params);
  }
}
